
import { useEffect, useState, useRef } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import ComplaintService from "../../services/complaintStatus/status";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const StatusDatable: React.FC<{ complaintStatus: any[] }> = ({ complaintStatus }) => {
  const { t } = useTranslation();
  const [complaintStatuss, setStatuses] = useState<any[]>([]);
  const toast = useRef<Toast>(null);

  useEffect(() => {
    fetchStatus();
  }, []);


  useEffect(() => {
    setStatuses(complaintStatus); // Sync with parent-provided filtered data
  }, [complaintStatus]);

  const fetchStatus = async () => {
    try {
      const response = await ComplaintService.getAllStatus();
      setStatuses(response);
   
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  };
  

  const showMessage = (label: string, message: string, severity: any) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };

  const nameEditor = (options: any) => {
    return (
      <InputText
        type="text"
        value={options.value}
        style={{ width: "95%" }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          options.editorCallback!(e.target.value)
        }
      />
    );
  };

  const subCategoryEditor = (options: any) => {
    return (
      <InputText
        type="text"
        value={options.value}
        style={{ width: "95%" }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          options.editorCallback!(e.target.value)
        }
      />
    );
  };

  const onRowEditComplete = async (event: DataTableRowEditCompleteEvent) => {
    const { newData, index } = event;
  const trimmedName = newData.name?.trim();

  if (!trimmedName) {
    showMessage("Validation Error", "Name cannot be empty!", "warn");
    return;
  }

  const isDuplicate = complaintStatuss.some((status, i) =>
    i !== index && status.name.trim().toLowerCase() === trimmedName.toLowerCase()
  );

  if (isDuplicate) {
    showMessage("Duplicate Entry", "Status name already exists!", "warn");
    return;
  }

    let updatedStatuses = [...complaintStatuss];
    if (updatedStatuses[index] !== newData) {
      updatedStatuses[index] = newData;
      setStatuses(updatedStatuses);

      try {
        const response = await ComplaintService.updateStatus(newData);
        if (response) {
          showMessage("Update Status", "Status updated successfully!", "success");
        } else {
          showMessage("Update Status", "Failed to update status.", "error");
        }
      } catch (error) {
        console.error("Error updating status:", error);
        showMessage("Update Status", "Error updating status.", "error");
      }
    }
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to delete "${rowData.name}"?`,
      header: "Confirm Deletion",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => handleDelete(rowData),
    });
  };

  const handleDelete = async (rowData: any) => {
    try {
      const success = await ComplaintService.deleteStatus(rowData.statusId);
      if (success) {
        const updatedStatuses = complaintStatuss.filter(
          (status) => status.statusId !== rowData.statusId
        );
        setStatuses(updatedStatuses);
        showMessage("Delete Status", "Status deleted successfully!", "success");
      } else {
        showMessage("Delete Status", "Failed to delete status.", "error");
      }
    } catch (error) {
      console.error("Error deleting status:", error);
      showMessage("Delete Status", "Error deleting status.", "error");
    }
  };

  return (
    <div className="col-12">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card border-noround p-2">
        <DataTable
          value={complaintStatuss}
          paginator
          rows={10}  
          stripedRows
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink "          currentPageReportTemplate="{first} to {last} of {totalRecords}"

          editMode="row"
          onRowEditComplete={onRowEditComplete}
        >
          <Column
            field="name"
            header={"Complaint Status"}
            editor={nameEditor}
            style={{ width: "25%" }}
          />
          <Column
            field="description"
            header={t("Description")}
            editor={subCategoryEditor}
            style={{ width: "25%" }}
          />
          <Column

/>
          <Column
            header={t("Edit")}
            rowEditor
            style={{ width: "10%" }}
          />
          <Column
            header={t("Delete")}
            body={(rowData) => (
              <Button
                icon="pi pi-trash"
                onClick={() => confirmDelete(rowData)}
                className="p-button-rounded p-button-danger p-button-text"
              />
            )}
            style={{ width: "8%" }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default StatusDatable;

